export default {
    // 我的车辆列表数据
    columns:[
        {
            title:'序号',
            type:'index'
        },
        {
            title:'车船号',
            dataIndex:"licensePlateNum",
            key:"licensePlateNum",
        },
        {
            title:'司机姓名',
            dataIndex:"driverName",
            key:"driverName"
        },
        {
            title:'手机号码',
            dataIndex:"driverPhone",
            key:"driverPhone"
        },
        {
            title:'身份证号',
            dataIndex:"driverIdCard",
            key:"driverIdCard"
        },
        {
          title:'押运员姓名',
          dataIndex:"escortsName",
          key:"escortsName"
        },
        {
            title:'押运员手机号',
            dataIndex:"escortsPhone",
            key:"escortsPhone"
        },
        {
            title:'押运员身份证号',
            dataIndex:"escortsIdCardNum",
            key:"escortsIdCardNum"
        },
        {
            title:'排放标准',
            dataIndex:"emissionStandard",
            key:"emissionStandard",
            slots:'emissionStandard',
        }, 
        {
            title:'创建日期',
            dataIndex:"createTime",
            key:"createTime"
        },
        {
            title:'更新日期',
            dataIndex:"updateTime",
            key:"updateTime",
        },
        {
            title: "操作",
            slots:'actions',
            width:150,
            fixed:'right'
        }
    ],

    // 详情关联司机列表
    driveColumns:[
        {
            title:'司机姓名',
            dataIndex:"realName",
            key:"realName"
        },
        {
            title:'联系方式',
            dataIndex:"phoneNumber",
            key:"phoneNumber"
        },
        {
            title:'身份证号',
            dataIndex:"idCard",
            key:"idCard"
        },
        {
            title: "操作",
            slots:'actions'
        }
    ],


    // 详情经营范围数据
    businessList:[
        {
          label: "一类(爆炸品)",
          value: '100',
        },
        {
          label: "二类(压缩气体和液化气体)",
          value: '101',
        },
        {
          label: "三类(易燃液体)",
          value: '102',
        },
        {
          label: "四类(易燃固体、自燃物品和遇湿易燃物品)",
          value: '103',
        },
        {
          label: "五类(氧化剂和有机过氧化物)",
          value: '104',
        },
        {
          label: "六类(毒害品和感染性物品)",
          value: '105',
        },
        {
          label: "七类(放射性物品)",
          value: '106',
        },
        {
          label: "八类(腐蚀品)",
          value: '107',
        },
        {
          label: "九类(杂类)",
          value: '108',
        },
        {
          label: "普通货物",
          value: '109',
        },
    ],

    // 车辆类型
    carModelList:[
      {
        label: "铝合金罐车",
        value: '100',
      },
      {
        label: "不锈钢不保温罐车",
        value: '101',
      },
      {
        label: "不锈钢保温罐车",
        value: '102',
      },
      {
        label: "不锈钢保温加热罐车",
        value: '103',
      },
      {
        label: "铁罐保温罐车",
        value: '104',
      },
      {
        label: "集装箱车",
        value: '105',
      },
      {
        label: "集装罐车",
        value: '106',
      },
      {
        label: "压力罐罐车",
        value: '107',
      },
      {
        label: "衬塑罐罐车",
        value: '108',
      },
      {
        label: "仓栏车",
        value: '109',
      },
      {
        label: "平板车",
        value: '110',
      },
      {
        label: "其他",
        value: '111',
      },
    ],

    // 排放标准
    vehicleEmissionsList:[
      {
        label: "国一",
        value: '01',
      },
      {
        label: "国二",
        value: '02',
      },
      {
        label: "国三",
        value: '03',
      },
      {
        label: "国四",
        value: '04',
      },
      {
        label: "国五",
        value: '05',
      },
      {
        label: "国六",
        value: '06',
      },
      {
        label: "氢能",
        value: '10',
      },
      {
        label: "电动",
        value: '11',
      },
    ],

    // 车牌颜色
    colorList: [
      {
        label: "白色",
        value: '0',
      },
      {
        label: "黄色",
        value: '1',
      },
      {
        label: "蓝色",
        value: '2',
      },
      {
        label: "黑色",
        value: '3',
      },
      {
        label: "黄绿色",
        value: '5',
      },
      {
        label: "绿色",
        value: '6',
      },
      {
        label: "其他",
        value: '7',
      },
    ],
    // 燃油类型
    fuelTypeList: [
      {
        label: "柴油",
        value: '01',
      },
      {
        label: "汽油",
        value: '02',
      },
      {
        label: "天然气",
        value: '03',
      },
      {
        label: "电动",
        value: '04',
      },
      {
        label: "氢能",
        value: '05',
      }
    ],
    // 环保车辆类型-股份
    vehicleTypeGufenList: [
      { label: "重型半挂牵引车", value: 'Q11' },
      { label: "重型普通货车", value: 'H11' },
      { label: "中型普通货车", value: 'H21' },
      { label: "轻型普通货车", value: 'H31' },
      { label: "微型普通货车", value: 'H41' },
      { label: "大型普通客车", value: 'K11' },
      { label: "中型普通客车", value: 'K21' },
      { label: "小型普通客车", value: 'K31' },
      { label: "小型轿车", value: 'K33' },
      { label: "重型非载货专项作业车", value: 'Z51' },
      { label: "重型罐式货车", value: 'H14' },
    ],
    // 环保车辆类型-重钢
    truckModelCGList: [
      { label: "1.25吨轻卡", value: 'CX25' },
      { label: "1.98吨轻卡", value: 'CX24' },
      { label: "15.4吨自卸车", value: 'CX04' },
      { label: "15.6吨自卸车", value: 'CX05' },
      { label: "15.8吨自卸车", value: 'CX10' },
      { label: "15吨自卸车", value: 'CX07' },
      { label: "16吨自卸车", value: 'CX06' },
      { label: "17.1吨自卸车", value: 'CX08' },
      { label: "17.8吨自卸车", value: 'CX09' },
      { label: "20吨平板车", value: 'CX12' },
      { label: "20吨气密罐车", value: 'CX16' },
      { label: "20吨自卸车", value: 'CX02' },
      { label: "30吨平板车", value: 'CX13' },
      { label: "30吨自卸车", value: 'CX01' },
      { label: "31吨平板车", value: 'CX14' },
      { label: "39.5吨牵引车", value: 'CX18' },
      { label: "40吨平板车", value: 'CX11' },
      { label: "40吨牵引车", value: 'CX20' },
      { label: "40吨吸排车", value: 'CX17' },
      { label: "40吨自卸车", value: 'CX03' },
      { label: "60吨平板车", value: 'CX15' },
      { label: "60吨牵引车", value: 'CX19' },
      { label: "70吨机架牵引车", value: 'CX23' },
      { label: "80吨高温牵引车", value: 'CX21' },
      { label: "90吨高温牵引车", value: 'CX22' },
      { label: "大型专项作业车", value: 'Z11' },
      { label: "混凝土泵车", value: 'X02' },
      { label: "加油用油罐车", value: 'CX28' },
      { label: "皮卡", value: 'CX26' },
      { label: "轻型半挂牵引车", value: 'Q31' },
      { label: "轻型仓栅式货车", value: 'H39' },
      { label: "轻型非载货专项作业车", value: 'Z712' },
      { label: "轻型封闭货车", value: 'H33' },
      { label: "轻型罐式货车", value: 'H34' },
      { label: "轻型货车", value: 'H30' },
      { label: "轻型栏板货车", value: 'H311' },
      { label: "轻型平板货车", value: 'H35' },
      { label: "轻型普通货车", value: 'H31' },
      { label: "轻型牵引车", value: 'A30' },
      { label: "轻型全挂牵引车", value: 'Q32' },
      { label: "轻型特殊结构货年", value: 'H38' },
      { label: "轻型厢式货车", value: 'H32' },
      { label: "轻型载货专项作业车", value: 'Z711' },
      { label: "轻型专项作业车", value: 'Z71' },
      { label: "轻型自卸货车", value: 'H37' },
      { label: "清淤车", value: 'CX27' },
      { label: "微型货车", value: 'H40' },
      { label: "微型专项作业车", value: 'Z41' },
      { label: "小型专项作业车", value: 'Z31' },
      { label: "中型半挂牵引车", value: 'Q21' },
      { label: "中型仓栅式货车", value: 'H29' },
      { label: "中型非载货专项作业", value: 'Z212' },
      { label: "中型封闭货车", value: 'H23' },
      { label: "中型罐式货车", value: 'H24' },
      { label: "中型货车", value: 'H20' },
      { label: "中型集装厢车", value: 'H26' },
      { label: "中型平板货车", value: 'H25' },
      { label: "中型普通货车", value: 'H21' },
      { label: "中型牵引车", value: 'Q20' },
      { label: "中型全挂牵引车", value: 'Q22' },
      { label: "中型特殊结构货车", value: 'H28' },
      { label: "中型厢式货车", value: 'H22' },
      { label: "中型载货专项作业", value: 'Z211' },
      { label: "中型专项作业车", value: 'Z21' },
      { label: "中型自卸货车", value: 'H27' },
      { label: "重型半挂牵引车", value: 'CX29' },
      { label: "重型半挂牵引车", value: 'Q11' },
      { label: "重型仓栅式货车", value: 'H19' },
      { label: "重型非载货专项作业车", value: 'Z62' },
      { label: "重型封闭货车", value: 'H13' },
      { label: "重型罐式货车", value: 'H14' },
      { label: "重型货车", value: 'H10' },
      { label: "重型集装厢车", value: 'H16' },
      { label: "重型栏板货车", value: 'H101' },
      { label: "重型平板货车", value: 'H15' },
      { label: "重型普通货车", value: 'H11' },
      { label: "重型牵引车", value: 'Q10' },
      { label: "重型全挂牵引车", value: 'Q12' },
      { label: "重型特殊结构货车", value: 'H18' },
      { label: "重型厢式货车", value: 'H12' },
      { label: "重型载货专项作业车", value: 'Z61' },
      { label: "重型专项作业车", value: 'Z51' },
      { label: "重型自卸货车", value: 'H17' },
      { label: "砼罐车", value: 'X01' },
    ],
    // 使用性质-股份
    usageTypeGufenList: [
      { label: "警用", value: 'H' },
      { label: "货运", value: 'F' },
      { label: "消防", value: 'I' },
      { label: "非营运", value: 'A' },
      { label: "工程抢险", value: 'K' },
      { label: "危化品运输", value: 'R' },
      { label: "其他", value: 'Z' },
    ],
    // 使用性质-重钢
    useCharCGList: [
      { label: "非营运", value: 'A' },
      { label: "营运", value: 'B' },
      { label: "特种车辆", value: 'C' },
      { label: "外籍车辆", value: 'D' },
      { label: "危化品运输", value: 'E' },
      { label: "货运", value: 'F' },
      { label: "工程救险", value: 'G' },
    ],
    // 联网状态
    onlineStatusList: [
      { label: "未联网", value: '0' },
      { label: "已联网", value: '1' },
    ],
}
